import './forgot-password-confirm.style.sass';
import template from './forgot-password-confirm.tpl.pug';

export default {
    selector: 'dbAForgotPasswordConfirm',
    template: template(),
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-confirm/forgot-password-confirm.cmpt.js